import React, { useState, useEffect, useRef } from 'react';
import { withApollo, graphql, compose } from 'react-apollo';
import Grid from '@material-ui/core/Grid';
import _get from 'lodash/get';

import gqlQueryGetApps from 'graphql/queries/get-apps';
import gqlQueryGetEnvContext from 'graphql/queries/get-env-context';
import clientGqlMutUpdateAppContext from 'graphql/mutations/update-app-context';
import ApplicationListGrid from 'components/applications/application-list-grid';
import PageHeader from 'components/page-header';
import Content from 'components/theme/content';
import ApplicationModifier from 'components/applications/application-modifier';
import EnvironmentModifier from 'components/applications/environment-modifier';
import ErrorBoundry from 'components/error-handler/error-boundry';
import withGraphqlLoaderHOC from 'components/theme/loader/with-graphql-loader-hoc';
import * as routeUtils from 'utils/routes';

function Applications(props) {
  const apps = _get(props, 'data.queryGetApps', []);
  const envContext = _get(props, 'data.queryEnvcontext[0]', {});
  const appIdRef = useRef();

  const [compState, setCompState] = useState({
    modifierAction: 'add',
    openAppModifier: false,
    openEnvModifier: false,
    appId: null
  });

  useEffect(() => {
    // No need to redirect if appId is not yet selected to change appContext
    if (!appIdRef.current) {
      return;
    }

    const { history } = props;
    history.push(
      routeUtils.build.pathFeaturesList(appIdRef.current, envContext.name)
    );
  }, [envContext.uId]);

  const onAppAdd = () => {
    setCompState((prevState) => ({ ...prevState, openAppModifier: true }));
  };

  const onEnvAdd = (appId) => {
    setCompState((prevState) => ({
      ...prevState,
      openEnvModifier: true,
      appId
    }));
  };

  const onAppSelect = (appId) => {
    const { client } = props;
    appIdRef.current = appId;

    const promise = client.mutate({
      mutation: clientGqlMutUpdateAppContext,
      variables: {
        appId
      }
    });
    promise.catch(console.warn);

    return false;
  };

  const closeAppModifier = () => {
    setCompState((prevState) => ({ ...prevState, openAppModifier: false }));
  };

  const closeEnvModifier = () => {
    setCompState((prevState) => ({ ...prevState, openEnvModifier: false }));
  };

  return (
    <>
      <PageHeader title="Applications" />
      <Content>
        <Grid container>
          <Grid item xs={12}>
            <ApplicationListGrid
              applicationsList={apps}
              onAppAdd={onAppAdd}
              onEnvAdd={onEnvAdd}
              onAppSelect={onAppSelect}
            />
          </Grid>
          <ErrorBoundry>
            <ApplicationModifier
              onClose={closeAppModifier}
              open={compState.openAppModifier}
              action={compState.modifierAction}
            />
            <EnvironmentModifier
              onClose={closeEnvModifier}
              open={compState.openEnvModifier}
              action={compState.modifierAction}
              appId={compState.appId}
            />
          </ErrorBoundry>
        </Grid>
      </Content>
    </>
  );
}

const ApplicationsWithGraphqlLoder = withGraphqlLoaderHOC(Applications, [
  { name: 'queryGetApps', data: 'listApplications.items' },
  {
    name: 'queryEnvcontext',
    data: 'envContext'
  }
]);

const ApplicationComponent = compose(
  graphql(gqlQueryGetApps, {
    name: 'queryGetApps'
  }),
  graphql(gqlQueryGetEnvContext, {
    name: 'queryEnvcontext'
  })
)(ApplicationsWithGraphqlLoder);

export default withApollo(ApplicationComponent);
